/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import("./utils/dd-rum");
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// async load stores to reduce app entry point size
import("./stores").then(async (stores) => {
  await stores.hydrateStores();

  const container = document.getElementById("app");

  if (container) createRoot(container).render(<App />);
});
